(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('SchedulingController', SchedulingController);

    SchedulingController.$inject = ['$scope', '$state', '$stateParams', 'entity'];

    function SchedulingController($scope, $state, $stateParams, entity) {
        var vm = this;
        vm.serviceItemId = $stateParams.id;
        vm.serviceItem = entity;


    }
})();
